import { isUndefined } from '@hcr/utils'

import type { EmptyPathParam } from '../../models'
import { EMPTY_PATH_PARAM } from '../../models'

export const isUndefinedOrEmptyPathParam = (x: unknown): x is EmptyPathParam | undefined =>
  x === EMPTY_PATH_PARAM || isUndefined(x)
